import React, { useState } from "react";
import PropTypes from "prop-types";
import { Popover, Link, Grid, Typography } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { RenderNotes } from '../../hooks/notes';

const styles = {
  smallText: {
    fontSize: 12,
    wordWrap: "break-word",
    fontStyle: "italic"
  },
  bold:{
    fontWeight:'bold'
  },
  italic:{
    fontSize:14
  },
  border: {
    border: "1px solid #F6F6F9",
    borderRadius: 10,
    background: "#F6F6F9",
    padding: 13,
    wordWrap: "break-word",
  },
  typography: {
    padding: 10,
    maxWidth: 262,
    maxHeight:250,
    overflowY: 'auto'
  },
};
const PopoverNotes = props => {

  const { classes } = props;
  let [anchorEl, setAnchorEl] = useState(null);
  let open = Boolean(anchorEl);
  return (
    <React.Fragment>
      <Link
        component="button"
        variant="body2"
        className={props.classes.smallText}
        onClick={e => {
          setAnchorEl(e.currentTarget);
        }}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        Read More
      </Link>
      <Popover
        id="simple-popper"
        anchorEl={anchorEl}
        open={open}
        onClose={() => {
            setAnchorEl(null);
          }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
      >
        <Grid container className={classes.typography}>
          <Grid item xs={12} className={classes.border}>
            <Typography className={classes.bold}> Timeline Notes: </Typography>
            { RenderNotes(props.notes, classes.italic) }
          </Grid>
        </Grid>
      </Popover>
    </React.Fragment>
  );
};

PopoverNotes.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(PopoverNotes);
